import { render, staticRenderFns } from "./desktopDeclination1.vue?vue&type=template&id=3ffaff2c&scoped=true&"
import script from "./desktopDeclination1.vue?vue&type=script&lang=ts&"
export * from "./desktopDeclination1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffaff2c",
  null
  
)

export default component.exports